import React, { lazy, Suspense } from 'react';

const LazyDonHangKhachHang = lazy(() => import('./DonHangKhachHang'));

const DonHangKhachHang = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyDonHangKhachHang {...props} />
  </Suspense>
);

export default DonHangKhachHang;
